import { render, staticRenderFns } from "./ClassRollCallTimeSlot.vue?vue&type=template&id=9c831238&scoped=true"
import script from "./ClassRollCallTimeSlot.vue?vue&type=script&lang=js"
export * from "./ClassRollCallTimeSlot.vue?vue&type=script&lang=js"
import style0 from "./ClassRollCallTimeSlot.vue?vue&type=style&index=0&id=9c831238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c831238",
  null
  
)

export default component.exports